import { Stack, Typography, useTheme } from "@mui/material";
import { Pencil } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationAddButton } from "web_myplann/Inspiration/Components/InspirationAddButton";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import { useRetirementStateNote } from "web_myplann/Inspiration/Retirement/Hooks/useRetirementStateNote";
import type { RetirementContext } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";

const R = Resources.Inspiration.Retirement;

type Props = {
	context: RetirementContext;
	onEdit: () => void;
};

export const RetirementStateSection: FC<Props> = ({ context, onEdit }) => {
	const { t } = useResource();
	const theme = useTheme();
	const { note, fromAgeNote, actionLabel } = useRetirementStateNote(context);

	return (
		<InspirationSection title={t(R.stateTitle)}>
			<Stack alignItems="center" textAlign="center" pb={theme.spacingTokens.md}>
				<Typography
					variant="h2"
					color={theme.palette.green.main}
					tabular
					mt={theme.spacingTokens.xs}
				>
					{formatInspirationMoney(context.statePension)}
					<Typography component="span" variant="button" color="inherit" muted>
						{t(R.perMonth)}
					</Typography>
				</Typography>
				<Typography
					variant="hint"
					color={theme.palette.grey[500]}
					relaxed
					mt={theme.spacingTokens.xsm}
				>
					{note}
				</Typography>
				{fromAgeNote && (
					<Typography
						variant="hint"
						color={theme.palette.grey[900]}
						strong
						relaxed
						mt={theme.spacingTokens.xs}
					>
						{fromAgeNote}
					</Typography>
				)}
			</Stack>
			<InspirationAddButton
				icon={Pencil}
				label={actionLabel}
				onClick={onEdit}
				divider
			/>
		</InspirationSection>
	);
};
